import type { SVGProps } from "react";
export interface AdobePsIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AdobePsIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AdobePsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M10.375 10.25c0-.621-.504-1.125-1.125-1.125H8.125v2.25H9.25c.621 0 1.125-.504 1.125-1.125M16 9.875c.691 0 1.39.274 1.863.582a1.125 1.125 0 0 1-1.226 1.886c-.204-.132-.482-.218-.637-.218a.8.8 0 0 0-.289.05c.096.055.255.123.495.168l.417.1c.413.123.818.318 1.16.603.473.396.842.987.842 1.736 0 .778-.397 1.393-.905 1.78a2.86 2.86 0 0 1-1.72.563c-.418 0-.824-.099-1.16-.229a3.3 3.3 0 0 1-.73-.388l-.215-.174-.082-.081a1.126 1.126 0 0 1 1.503-1.66l.09.073.018.015q.02.015.055.035a1.2 1.2 0 0 0 .521.159c.154 0 .277-.05.344-.097l-.003-.003c-.085-.072-.267-.167-.549-.22-.526-.098-1.084-.296-1.541-.656-.484-.383-.846-.952-.874-1.68l-.002-.044c0-1.481 1.352-2.3 2.625-2.3m-3.375.375a3.375 3.375 0 0 1-3.375 3.375H8.125v2.374a1.125 1.125 0 0 1-2.25 0V8.215c0-.74.6-1.339 1.339-1.339H9.25a3.375 3.375 0 0 1 3.375 3.375"
      />
    </svg>
  );
}
